import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

interface PublicLayoutProps {
    onLoginClick: () => void;
    onRegisterClick: () => void;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ onLoginClick, onRegisterClick }) => {
    return (
        <div className="flex flex-col min-h-screen">
            <Navbar
                onLoginClick={onLoginClick}
                onRegisterClick={onRegisterClick}
            />

            <main className="flex-grow">
                <Outlet />
            </main>

            <Footer />
        </div>
    );
};

export default PublicLayout;